const CONFIGS = {
  common: {
    position: 'top-right',
    duration: 5000,
    keepOnHover: true,
    iconPack: 'fontawesome',
    theme: 'toasted-primary'
  },
  error: {
    type: 'error'
  },
  success: {
    type: 'success'
  },
  info: {
    type: 'info'
  }
};

export default {
  install(Vue, { engine }) {
    Vue.prototype.$notify = {
      error(message) {
        const toast = engine.show(message, {
          ...CONFIGS.common,
          ...CONFIGS.error
        });

        toast.el.addEventListener('click', () => toast.goAway(0));

        return toast;
      },
      success(message) {
        const toast = engine.show(message, {
          ...CONFIGS.common,
          ...CONFIGS.success
        });

        toast.el.addEventListener('click', () => toast.goAway(0));

        return toast;
      },
      info(message) {
        const toast = engine.show(message, {
          ...CONFIGS.common,
          ...CONFIGS.info
        });

        toast.el.addEventListener('click', () => toast.goAway(0));

        return toast;
      }
    };
  }
};
